<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 offset-md-3 offset-md-3 mt-5">
                <app-card :title="$t('Reset password')">
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="send(validate)">
                            <div class="alert alert-success" role="alert" v-if="status">
                                {{ status }}
                            </div>

                            <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">
                                <template #label>
                                    {{ $t('Email') }}*
                                </template>
                            </app-input>

                            <app-button :loading="loading" small>
                                {{ $t('Send password reset link') }}
                            </app-button>
                            <router-link to="/auth/login" class="btn btn-outline-info btn-sm ml-2" exact>
                                {{ $t('Log in') }}
                            </router-link>
                            <!--                            <router-link to="/auth/register" class="btn btn-outline-info btn-sm ml-2" exact>-->
                            <!--                                {{ $t('Register') }}-->
                            <!--                            </router-link>-->
                            <router-link to="/" class="btn btn-outline-success btn-sm ml-2" exact>
                                {{ $t('Public') }}
                            </router-link>
                        </form>
                    </validation-observer>
                </app-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            status: '',
            loading: false,
            form: {
                email: ''
            }
        };
    },
    methods: {
        send(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    axios.post('/password/email', this.form).then(res => {
                        this.status = res.data.status;
                        this.loading = false;
                    });
                }
            });
        }
    }
};
</script>
